import type { ReactNode } from 'react';

const SEPARATOR = ',';

class AddressBuilder {
  private fullAddress: ReactNode;

  constructor() {
    this.fullAddress = '';
  }

  basicAddress(
    name?: string,
    websiteUrl?: string,
    websiteHypertext?: string,
    address?: string,
    trackNobookingCta?: () => void,
  ) {
    this.fullAddress = (
      <>
        {name}: {address}
      </>
    );
    if (websiteUrl) {
      const weblink = (
        <a
          href={websiteUrl}
          className="Footer-website"
          target="__blank"
          onClick={trackNobookingCta}
          data-testid="footer-client-weblink"
        >
          {websiteHypertext || websiteUrl}
        </a>
      );
      this.fullAddress = (
        <>
          <p className="Footer-addressItem">
            {name}: {weblink}
          </p>
          {address}
        </>
      );
    }
    return this;
  }

  add(detail?: string) {
    if (!detail) {
      return this;
    }

    this.fullAddress = (
      <>
        {this.fullAddress}
        {SEPARATOR} {detail}
      </>
    );
    return this;
  }

  render() {
    return this.fullAddress;
  }
}

export { AddressBuilder };
